<template>
  <v-container>
    <p class="step-title">{{ $t('physiciansStep.familyDoctor') }}</p>
    <HfrCard v-if="userInfo && Object.keys(userInfo).length > 0">
      <div class="field-warning mb-0">{{ $t('global.prefilledDataWarning') }} </div>
    </HfrCard>
    <v-form ref="doctorForm">
      <HfrCard>
        <v-checkbox
          v-model="form.noFamilyDoctor"
          :label="$t('physiciansStep.noFamilyDoctor')"></v-checkbox>
        <div v-if="form.noFamilyDoctor !== true">
          <v-text-field
            v-model="form.familyDoctor.lastName"
            :label="$t('physiciansStep.lastName')"
            filled
            class="required"
            :rules="[rules.required]"></v-text-field>
          <v-text-field
            v-model="form.familyDoctor.firstName"
            :label="$t('physiciansStep.firstName')"
            filled
            class="required"
            :rules="[rules.required]"></v-text-field>
          <v-text-field
            v-model="form.familyDoctor.street"
            :label="$t('global.street')"
            filled>
          </v-text-field>
          <v-text-field
            v-model="form.familyDoctor.zip"
            :label="$t('global.zip')"
            filled
            class="required"
            :rules="[rules.required]">
          </v-text-field>
          <v-text-field
            v-model="form.familyDoctor.city"
            :label="$t('global.city')"
            filled
            class="required"
            :rules="[rules.required]">
          </v-text-field>
          <phone-field
            v-model="form.familyDoctor.phone"
            :label="$t('global.mobilePhone')">
          </phone-field>
        </div>
      </HfrCard>
      <p class="step-title mt-3">{{ $t('physiciansStep.senderDoctor') }}</p>
      <HfrCard>
        <v-checkbox
          v-model="form.noSenderDoctor"
          :label="$t('physiciansStep.noSenderDoctor')"></v-checkbox>
        <div v-if="form.noSenderDoctor !== true">
          <v-text-field
            v-model="form.senderDoctor.lastName"
            :label="$t('global.lastName')"
            filled
            class="required"
            :rules="[rules.required]"></v-text-field>
          <v-text-field
            v-model="form.senderDoctor.firstName"
            :label="$t('global.firstName')"
            filled
            class="required"
            :rules="[rules.required]"></v-text-field>
          <v-text-field
            v-model="form.senderDoctor.street"
            :label="$t('global.street')"
            filled>
          </v-text-field>
          <v-text-field
            v-model="form.senderDoctor.zip"
            :label="$t('global.zip')"
            filled
            class="required"
            :rules="[rules.required]">
          </v-text-field>
          <v-text-field
            v-model="form.senderDoctor.city"
            :label="$t('global.city')"
            filled
            class="required"
            :rules="[rules.required]">
          </v-text-field>
          <phone-field
            v-model="form.senderDoctor.phone"
            :label="$t('global.mobilePhone')">
          </phone-field>
        </div>
      </HfrCard>
    </v-form>
  </v-container>
</template>
<script>
import HfrCard from '@/components/ui/HfrCard';
import { mapActions, mapState } from 'vuex';
import PhoneField from "@/components/ui/PhoneField.vue";
export default {
  components: {PhoneField, HfrCard },
  data() {
    return {
      stepNumber: 7,
      form: {
        noFamilyDoctor: null,
        familyDoctor: {
          firstName:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Gregory' : null,
          lastName:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'House' : null,
          street:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'HollyBoul' : null,
          zip: process.env.VUE_APP_PREFILL_FORMS === 'true' ? '1988' : null,
          city:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Los Angeles' : null,
          phone:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? '+41/786785851' : null
        },
        noSenderDoctor: null,
        senderDoctor: {
          firstName:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Number' : null,
          lastName:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Treize' : null,
          street:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? '5th Avenue' : null,
          zip: process.env.VUE_APP_PREFILL_FORMS === 'true' ? '1988' : null,
          city:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'New York' : null,
          phone:
            process.env.VUE_APP_PREFILL_FORMS === 'true' ? '+411/786785858' : null
        }
      },
      rules: {
        required: (value) => !!value || 'Ce champs est requis.',
      }
    };
  },
  watch: {
    userInfo: {
      handler() {
        this.fillFormDataWithUserInfo();
      }
    },
    navigateToNextStep: {
      handler(navigateToNextStep) {
        if (this.currentStep == this.stepNumber && navigateToNextStep) {
          this.validateDoctorForm();
        }
      }
    }
  },
  methods: {
    ...mapActions('navigation', ['doNextStep', 'toggleNavigateToNextStep']),
    ...mapActions('preAdmission', ['storeDoctorStep']),
    validateDoctorForm() {
      if (this.$refs.doctorForm.validate()) {
        this.storeDoctorStep(this.form);
        this.doNextStep();
      }

      this.toggleNavigateToNextStep();
    },
    fillFormDataWithUserInfo() {
      this.form.noFamilyDoctor = null
      this.form.noSenderDoctor = null
      var familyDoctor = this.userInfo?.physicians?.find((p) => p.type === 'F');
      var senderDoctor = this.userInfo?.physicians?.find((p) => p.type === 'S');

      this.form.senderDoctor = {
        firstName: senderDoctor?.first_name,
        lastName: senderDoctor?.last_name,
        street: senderDoctor?.addresses[0]?.street,
        zip: senderDoctor?.addresses[0]?.zip_code,
        city: senderDoctor?.addresses[0]?.city,
        phone: senderDoctor?.phones[0]?.number
      }
      this.form.familyDoctor = {
        firstName: familyDoctor?.first_name,
        lastName: familyDoctor?.last_name,
        street: familyDoctor?.addresses[0]?.street,
        zip: familyDoctor?.addresses[0]?.zip_code,
        city: familyDoctor?.addresses[0]?.city,
        phone: familyDoctor?.phones[0]?.number
      }
      this.$refs.doctorForm.resetValidation();
    }
  },
  computed: {
    ...mapState('preAdmission', ['userInfo']),
    ...mapState('navigation', ['navigateToNextStep', 'currentStep'])
  }
};
</script>
